import React from "react";

const WeChatPay = (props) => (
  <svg width={32} height={32} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.91 19.447a1.01 1.01 0 01-1.322-.397l-.065-.141-2.73-5.886a.505.505 0 01-.049-.207c0-.272.224-.491.5-.491.113 0 .216.036.3.097l3.222 2.254a1.511 1.511 0 001.332.15L28.253 8.2C25.536 5.055 21.063 3 16 3 7.715 3 1 8.497 1 15.279c0 3.7 2.02 7.03 5.183 9.281.253.178.42.47.42.8 0 .11-.024.209-.053.313l-.676 2.477c-.031.116-.08.237-.08.359 0 .271.223.491.5.491.108 0 .197-.04.288-.091l3.284-1.863c.247-.14.509-.227.797-.227.153 0 .301.024.44.066 1.533.432 3.185.673 4.897.673 8.284 0 15-5.498 15-12.279 0-2.054-.62-3.988-1.709-5.69l-17.27 9.795-.11.063z"
      fill="#1AAD19"
      fillRule="nonzero"
    />
  </svg>
);

export default WeChatPay;
